import aiLineImg from "@/assets/cut-mix-detail/ai_line.png";
import clockImg from "@/assets/cut-mix-detail/clock_blue.png";
import SmartSearch from "@/components/business/SmartSearch";
import { useContext, useEffect, useRef, useState } from "react";
import Intelligent from "@/components/business/Intelligent";
import { Checkbox, Message, Tooltip } from "@arco-design/web-react";
import { observer } from "mobx-react";
import MyEditor from "@/components/business/MyEditor";
import lineImg from "@/assets/cut-mix-detail/color_sound.png";
import captionPlayerImg from "@/assets/cut-mix-detail/caption-playing.gif";
import loadingSvg from "@/assets/create-space/loading.svg";
import {
  VideoConfigCardContainer,
  VideoConfigCardHeader,
} from "../../UIComponents/VideoConfigCard/VideoConfigCard";
import TitleGroup from "../../FontTitle/TitleGroup/TitleGroup";
import usePreviewConfig from "@/useStore/preview/usePreview";
import useCaption from "@/useStore/mixCutDetail/useCaption";
import { mixCutDetailContext } from "../../MixCutDetail";
import useAudioPlayer from "@/requestHooks/mixCutDetail/useAudioPlayer";
import { useEditorHelper } from "@/components/business/MyEditor/helper";
import clearBlue from "@/assets/cut-mix-detail/clear_blue.png";
import { estimateDuration } from "@/utils/perm";
import clock from "@/assets/cut-mix-detail/clock_#ccc.png";
import "./VoiceLine.less";
import { toJS } from "mobx";
import { timer } from "@/assets/workbenchimage";
import { checkLanguage } from "@/utils/judgment";
import useClickOutside from "@/hooks/useClickOutside";

export const formatPreviewTimeSeconds = (input: number | string) => {
  const seconds = Number(input);
  if (isNaN(seconds) || seconds === undefined) {
    return "00:00";
  }
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
  const formattedSeconds =
    remainingSeconds < 10 ? "0" + remainingSeconds : remainingSeconds;
  return formattedMinutes + ":" + formattedSeconds;
};

export interface IVoiceLine {
  style: React.CSSProperties;
  onChange: (e: string[], str: any, playContent: string) => void;
  value: string[][];
  captionEditorIndex: number;
  onCaptionEditorIndexChange: (e: number) => void;
  handleAddButtonClick: () => void;
  handleDeleteButtonClick: (index: number) => void;
  sensitiveData: any;
  selector: any;
}

export interface editorItem {
  type: "text";
  text: string;
}

export interface editorValueType {
  type: "paragraph";
  content: editorItem[];
}

const VoiceLine: React.FC<IVoiceLine> = observer((props) => {
  const {
    style,
    onChange,
    value,
    captionEditorIndex,
    onCaptionEditorIndexChange,
    handleAddButtonClick,
    handleDeleteButtonClick,
    sensitiveData,
    selector,
  } = props;
  const { videoGroupActive } = useContext(mixCutDetailContext);
  const { projectCaption, hanldeCaptionTextSettingGlobleChange } = useCaption();
  const { handleClipIdChange, handlePreviewCaptionChange } = usePreviewConfig();
  const [aiSearchState, setAiSearchState] = useState<boolean>(false);
  const [intelligenceState, setIntelligenceState] = useState<boolean>(false);
  const aiSearchRef = useRef<HTMLDivElement>(null);
  const {
    isPlaying,
    stopAudio,
    playAudio,
    loading: isLoading,
  } = useAudioPlayer();
  // smart所用
  const [smartValue, setSmartValue] = useState("");
  const [smartStatus, setSmartStatus] = useState("");
  const [sendSmartStatus, setSendSmartStatus] = useState("");
  const [itelligentIsExecution, setItelligentIsExecution] = useState(true);
  // 编辑器光标位置
  const [selectInfo, setSelectInfo] = useState({
    index: -1,
    range: {
      from: -1,
      to: -1,
    },
  });
  const [editLength, setEditLength] = useState<number>(0);
  const calculatorCaptionTime = () => {
    const caption = ((projectCaption || [])[videoGroupActive] || [])[
      captionEditorIndex
    ];

    const time = estimateDuration(
      caption?.content.map(
        (str) =>
          str
            .replace(/>\s+</g, "><") // 移除标签之间的空白
            .replace(/\s{2,}/g, " ") // 将多个空白字符替换为一个空格
            .replace(/<speak>\s+/g, "<speak>") // 移除 <speak> 标签后多余的空白
            .replace(/\s+<\/speak>/g, "</speak>") // 移除 </speak> 标签前多余的空白
            .trim() // 去除字符串首尾的空白
      ) || [],
      (caption?.voice_setting?.default_speed_rate || 20) / 100,
      true,
      caption?.voice_setting?.lang == "en"
    );
    return (time || 0).toFixed(0);
  };

  const toPlayStateGetImg = (index: number) => {
    if (isLoading === true)
      return (
        <img
          onClick={() => {
            stopAudio();
          }}
          src={loadingSvg}
          alt=""
        />
      );
    if (isPlaying === true)
      return (
        <img
          onClick={() => {
            stopAudio();
          }}
          src={captionPlayerImg}
          alt=""
        />
      );
    return (
      <Tooltip content={<>最长试听30s</>} style={{ cursor: "pointer" }}>
        <img
          style={{ cursor: "pointer" }}
          onClick={() => {
            handlePlayerCaption(index, selector);
          }}
          src={lineImg}
          alt=""
        />
      </Tooltip>
    );
  };

  const handlePlayerCaption = async (index: number, selector) => {
    try {
      const [helper] = useEditorHelper(editorRef.current.editor);
      const item = projectCaption[videoGroupActive][index];
      const str = item.content
        .map((item) => item.replace(/<\/?speak>/g, ""))
        .join("");
      if (!checkLanguage(item.voice_setting.lang, str) && selector !== 6) {
        Message.error("请选择与台词语言一致的配音选项");
        return;
      }
      if (item.content.join(",").length > 0) {
        await playAudio(
          {
            line: helper
              .exportMaxFontSizeSSML(120)
              .replace(/\n\n/g, ",")
              .replace(/\n/g, ""),
            speaker_id: item.voice_setting.speaker_id,
            speed_ratio: item.voice_setting.speed_ratio,
            volume_ratio: item.voice_setting.volume_ratio,
            pitch_ratio: item.voice_setting.pitch_ratio,
          },
          selector === 6 ? "custom" : "official"
        );
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    stopAudio();
  }, [captionEditorIndex]);

  useEffect(() => {
    const editor = editorRef.current.editor;
    const [helper] = useEditorHelper(editor);
    setSelectInfo({ ...selectInfo, range: helper.getSelectionSSML() });
  }, [captionEditorIndex, videoGroupActive]);

  useClickOutside({
    ref: aiSearchRef,
    handler: () => {
      setAiSearchState(false);
      // setIntelligenceState(false);
      setItelligentIsExecution(true);
    },
    isActive: aiSearchState,
  });

  const toValueGetTitleGroup = () => {
    return value.map((_, index) => {
      return {
        value: index,
        title: "台词组" + (index + 1),
      };
    });
  };

  const handleClickInterlligent = (opt) => {
    const edit = editorRef.current.editor;
    const [helper] = useEditorHelper(edit);
    const { from, to } = helper.getSelectionSSML();
    switch (opt.type) {
      case "change":
        if (from === to) {
          edit.commands.focus("all");
          edit.commands.insertContent(opt.text);
        } else {
          edit.commands.insertContentAt(selectInfo.range, opt.text, {
            updateSelection: true,
            parseOptions: {
              preserveWhitespace: "full",
            },
          });
        }
        Message.success("替换成功");
        break;
      case "copy":
        navigator.clipboard.writeText(opt.text);
        Message.success("复制成功");
        break;
      case "splice":
        edit.commands.insertContentAt(selectInfo.range, opt.text, {
          updateSelection: true,
          parseOptions: {
            preserveWhitespace: "full",
          },
        });
        Message.success("添加成功");
        break;
      default:
        break;
    }
  };

  const editorRef = useRef<any>(null);
  return (
    <div className="voice-line-wrapper" style={style}>
      <TitleGroup
        maxLength={15}
        active={captionEditorIndex}
        titleCopy="添加台词组"
        style={{ marginTop: 12, marginBottom: 12 }}
        handleActiveIndexChange={(index) => {
          onCaptionEditorIndexChange(index);
        }}
        data={toValueGetTitleGroup()}
        handleAddBtnClick={() => {
          handleAddButtonClick();
        }}
        isEdit={true}
        handleDeleteBtnClick={(e) => {
          if (value.length === 1) {
            Message.error("必须保持有一个台词组！");
            return;
          }
          if (e === 0 && captionEditorIndex === 0) {
            handlePreviewCaptionChange(
              ((projectCaption || [])[videoGroupActive] || [])[
                captionEditorIndex + 1
              ] || null
            );
            handleClipIdChange(null);
          }
          if (captionEditorIndex === e) {
            onCaptionEditorIndexChange(0);
          }
          if (captionEditorIndex > e) {
            onCaptionEditorIndexChange(captionEditorIndex - 1);
          }
          handleDeleteButtonClick(e);
        }}
      ></TitleGroup>
      <>
        <VideoConfigCardHeader
          style={{ marginTop: "20px" }}
          headerLeft={
            <span className="header-left">
              台词文案 {toPlayStateGetImg(captionEditorIndex)}
            </span>
          }
          headerRight={
            <>
              <Checkbox
                checked={
                  ((projectCaption || [])[videoGroupActive] || [])[
                    captionEditorIndex
                  ]?.text_setting?.is_global
                }
                onChange={(e) => {
                  hanldeCaptionTextSettingGlobleChange(
                    videoGroupActive,
                    captionEditorIndex,
                    e
                  );
                }}
              >
                <span
                  style={{
                    fontSize: 12,
                    color: "#333333",
                  }}
                >
                  同步位置到全局
                </span>
              </Checkbox>
            </>
          }
        ></VideoConfigCardHeader>
        <VideoConfigCardContainer style={{ padding: 10, paddingBottom: 0 }}>
          <div
            style={{
              position: "relative",
            }}
          >
            <MyEditor
              forbid={sensitiveData}
              // isFormat
              ref={(ref) => {
                editorRef.current = ref;
              }}
              content={
                value[captionEditorIndex] && value[captionEditorIndex].length
                  ? value[captionEditorIndex]
                  : [
                      {
                        type: "listItem",
                        content: [
                          {
                            type: "paragraph",
                          },
                        ],
                      },
                    ]
              }
              placeholder={"请输入台词文案, shift+enter行内折行，文案中一旦出现标点符号，系统将默认开启下一句台词"}
              type={"caption"}
              singleLine={100}
              limit={1000}
              handleblur={() => {
                // handleClipIdChange(null);
              }}
              resTextLength={setEditLength}
              limitPosition={{
                display: "none",
              }}
              handlefocus={() => {
                onCaptionEditorIndexChange(captionEditorIndex);
                handleClipIdChange(
                  projectCaption[videoGroupActive][captionEditorIndex].id
                );
              }}
              handleUpdate={(val) => {
                const data = (
                  editorRef.current.editor.getJSON().content[0].content || []
                ).map((node) => {
                  return `<speak>${editorRef.current.helper.formatNodeToSSML(node).replace(/\n\n/g, "")}</speak>`;
                });
                const playContent = editorRef.current.editor
                  .getText()
                  .replace("/\n", " ");
                onChange(data, val, playContent);
              }}
              selected={({ value, range }) => {
                setSmartValue(
                  value ||
                    editorRef.current.editor
                      .getText()
                      .replace(/\n\n\n\n/g, "\n")
                      .slice(1)
                );
                setSelectInfo({
                  index: -1,
                  range,
                });
              }}
              selectInfo={selectInfo}
            />
          </div>

          <div className="voice-container-bar">
            <div
              className="insert-opeator"
              style={{ position: "relative" }}
              ref={aiSearchRef}
            >
              {/* 智能文案 */}
              <img
                style={{ marginRight: 6 }}
                src={aiLineImg}
                alt=""
                className="ai-line"
                onClick={() => {
                  setAiSearchState(!aiSearchState);
                  // setIntelligenceState(false);
                  setItelligentIsExecution(true);
                }}
              />
              <div
                className="tags insert-stop"
                onClick={(e) => {
                  e.stopPropagation();
                  editorRef.current.addBreak({
                    time: "0.5s",
                  });
                  setAiSearchState(false);
                  setIntelligenceState(false);
                  setItelligentIsExecution(true);
                }}
                style={{ marginRight: 6, cursor: "pointer" }}
              >
                <img src={clockImg} alt=""></img>
                插入停顿
              </div>
              <div
                style={{ cursor: "pointer" }}
                className="tags insert-stop"
                onClick={() => {
                  onChange(
                    [],
                    [
                      {
                        type: "listItem",
                        content: [
                          {
                            type: "paragraph",
                          },
                        ],
                      },
                    ],
                    ""
                  );
                  handleClipIdChange(null);
                }}
              >
                <img src={clearBlue} alt="" />
                清空内容
              </div>
              {aiSearchState ? (
                <SmartSearch
                  disStopPropagation
                  placeholder={"帮我写..."}
                  styles={{
                    marginLeft: "107px",
                    width: "468px",
                  }}
                  handelClickBtn={(value: string, type: string) => {
                    setSmartStatus(type);
                    setSendSmartStatus(value);
                    setAiSearchState(false);
                    setIntelligenceState(true);
                  }}
                  editValue={smartValue}
                  isEnd={itelligentIsExecution}
                  handleKeyDown={(event) => {
                    if (
                      event.key === "Escape" ||
                      event.keyCode === 27 ||
                      event.key === "Enter"
                    ) {
                      // setAiSearchState(false);
                      setIntelligenceState(true);
                      setItelligentIsExecution(true);
                    }
                  }}
                />
              ) : (
                <></>
              )}
            </div>
            <div className="preview-time">
              <div className="preview-info">
                <img src={timer} alt="" style={{ marginRight: 2 }} />
                {formatPreviewTimeSeconds(calculatorCaptionTime())}
              </div>
              &emsp;<div>{editLength}/1000</div>
            </div>
          </div>
        </VideoConfigCardContainer>
      </>
      {intelligenceState ? (
        <Intelligent
          style={{
            width: "405px",
            top: 73,
            position: "fixed",
            right: 0,
            bottom: 0,
            height: "calc(100vh - 85px)",
            zIndex: 1000,
          }}
          defaultStatus={smartStatus}
          value={sendSmartStatus}
          isInExecution={setItelligentIsExecution}
          handleOnChange={(e) => {
            handleClickInterlligent(e);
          }}
          handleCloseBtnClick={() => {
            setSendSmartStatus("");
            setIntelligenceState(false);
            setItelligentIsExecution(true);
            setAiSearchState(aiSearchState);
          }}
        />
      ) : (
        <></>
      )}
    </div>
  );
});

export default VoiceLine;
